var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-gray-500 text-center pt-1 pb-4 text-sm font-thin"},[_vm._v("App version: "+_vm._s(_vm.appVersion))])}
var staticRenderFns = []

export { render, staticRenderFns }